enum Roles {
  Admin = "Admin",
  User = "User",
}

export default Roles;